import { render } from "./ListeMpostBoxPage.vue?vue&type=template&id=72bc3783&ts=true"
import script from "./ListeMpostBoxPage.vue?vue&type=script&lang=ts"
export * from "./ListeMpostBoxPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__